var map = {
	"./1 Nirakar Chhayya.jpg": 7638,
	"./2 Nirakar Chhayya.jpg": 6177,
	"./4 Nirakar Chhayya.jpg": 2523,
	"./6 Nirakar Chhayya.jpg": 2829,
	"./7 Nirakar Chhayya.jpg": 8996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3770;